import React from "react";

const ShikaLogo = ({ 
    size = 32, 
    style = {}, 
    alt = "Shika AI",
    ...props 
}) => {
    return (
        <img 
            src="/shika_logo.png" 
            alt={alt} 
            style={{ 
                width: `${size}px`, 
                height: `${size}px`, 
                objectFit: "contain",
                ...style
            }} 
            {...props}
        />
    );
};

export default ShikaLogo; 